import { Injectable } from '@angular/core';
import { LinqFilterDTO, LinqFilterType, LinqPredicateDTO } from '../models/linqPredicate.model';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})

export class FilterService {

  constructor() {
  }

  /**
   * Compone il predicato LINQ che servirà per recuperare la gerarchia degli elementi in base alla company.
   * In questo modo sarà possibile, per una qualsiasi entità, restituire tutti i record che appartengono a una specifica company.
   * @param FKCompany_PropertyName Nome della proprietà su cui è contenuto l'ID della company di riferimento
   */
  getCompanyHierarchyFilter(FKCompany_PropertyName: string, includeDefaultCompany: boolean = true): Array<LinqPredicateDTO> {

    let predicatesResult: Array<LinqPredicateDTO> = new Array<LinqPredicateDTO>();
    let FK_Company = GlobalService.getUsedCompany();

    let predicate: LinqPredicateDTO = new LinqPredicateDTO();
    predicate.PropertyFilters = new Array<LinqFilterDTO>();

    if (FK_Company) {
      predicate.PropertyFilters.push(LinqFilterDTO.createFilter(FKCompany_PropertyName, FK_Company, LinqFilterType.Equal));
    }

    if (includeDefaultCompany == true) {
      predicate.PropertyFilters.push(LinqFilterDTO.createFilter(FKCompany_PropertyName, null, LinqFilterType.Equal));
    }

    predicatesResult.push(predicate);

    return predicatesResult;
  }

  /**
   * Compone il predicato LINQ che servirà per recuperare la gerarchia degli elementi in base alla company.
   * In questo modo sarà possibile, per una qualsiasi entità, restituire tutti i record che appartengono a una specifica company.
   * @param FKCompany_PropertyName Nome della proprietà su cui è contenuto l'ID della company di riferimento
   */
  getVatRateFilter(FKCompany_PropertyName: string, includeDefaultCompany: boolean = true): Array<LinqPredicateDTO> {

    let predicatesResult: Array<LinqPredicateDTO> = new Array<LinqPredicateDTO>();
    let FK_Company = GlobalService.getUsedCompany();

    let predicate: LinqPredicateDTO = new LinqPredicateDTO();
    predicate.PropertyFilters = new Array<LinqFilterDTO>();

    if (FK_Company) {
      predicate.PropertyFilters.push(LinqFilterDTO.createFilter(FKCompany_PropertyName, FK_Company, LinqFilterType.Equal));
    }

    if (includeDefaultCompany == true) {
      predicate.PropertyFilters.push(LinqFilterDTO.createFilter(FKCompany_PropertyName, null, LinqFilterType.Equal));
    }

    predicate.PropertyFilters.push(LinqFilterDTO.createFilter("IsActive", true, LinqFilterType.Equal))

    predicatesResult.push(predicate);

    return predicatesResult;
  }

}
